import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import Slot from "./Slot.es.js";
const EzPreview = forwardRef((props, ref) => /* @__PURE__ */ jsx(Slot, { element: "figure", slot: "preview", ref, ...props }));
EzPreview.displayName = "EzPreview";
export {
  EzPreview as default
};
//# sourceMappingURL=EzPreview.es.js.map
